import {PopulateDataHandler} from "../../../infrastructure/handlers/populate-data-handler";

export class CompetitionsSliderWidgetPopulateDataHandler extends PopulateDataHandler {}
